import React, { useRef, useEffect } from "react";

function ZoomSafeComponent({ children }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    const handleTouchMove = (e) => {
      if (e.touches.length > 1) {
        e.preventDefault(); // Blocca il pinch zoom
      }
    };

    if (container) {
      container.addEventListener("touchmove", handleTouchMove, { passive: false });
    }

    return () => {
      if (container) {
        container.removeEventListener("touchmove", handleTouchMove);
      }
    };
  }, []);

  return (
    <div ref={containerRef} style={{ touchAction: "pan-y" }}>
      {children}
    </div>
  );
}

export default ZoomSafeComponent;
